import { h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import waitForElement from '../utils/waitForElement';

const ShopPay = () => {

  const ref = useRef(null);

  const { enableShopPay } = JSON.parse(document.querySelector('[data-technical]').textContent);

  useEffect(() => {
    const findElements = setTimeout(async () => {
      const element = await waitForElement('.shopify-payment-terms shopify-payment-terms');
      const cloned = element.cloneNode(true);
      ref.current.append(cloned);
    }, 300);
    return () => clearTimeout(findElements);
  }, []);

  return (
    enableShopPay && (
      <div className="text-left pb-1">
        <div ref={ref} className={'shopify-payment-terms body-2 text-secondary'} />
      </div>
    ) 
  );
};

export default ShopPay;